// https://docs.google.com/document/d/1Fl29DCAGLiGXo77CJ_f7CmgtsLV7itH6Wp_b-xCsZj0/edit?tab=t.0

export enum Stratege {
  'TrendFollowing' = 'Trend-Following', // 趋势跟踪策略
  'MeanReversion' = 'Mean Reversion', // 均值回归策略
  'EventDriven' = 'Event-Driven', // 事件驱动策略
}

export const strategies = [
  {
    value: 'Trend-Following', // 趋势跟踪策略
    label: 'Trend-Following',
  },
  {
    value: 'Mean Reversion', // 均值回归策略
    label: 'Mean Reversion',
  },
  {
    value: 'Event-Driven', // 事件驱动策略
    label: 'Event-Driven',
  },
];

export const presetStrategeQueries: Record<Stratege, Record<string, string>> = {
  [Stratege.EventDriven]: {
    'Multi-Indicator Trend Strategy': 'Multi-Indicator Trend Strategy Query',
    'Channel Breakout Trend Strategy': 'Channel Breakout Trend Strategy Query',
  },
  [Stratege.MeanReversion]: {
    'Bollinger Band Mean Reversion Strategy': 'Bollinger Band Mean Reversion Strategy Query',
    'RSI Overbought/Oversold Strategy': 'RSI Overbought/Oversold Strategy Query',
  },
  [Stratege.TrendFollowing]: {
    'Interest Rate Decision Events': 'Interest Rate Decision Events Query',
    'Macroeconomic Data Releases': 'Macroeconomic Data Releases Query',
    'Project On-Chain and Ecosystem Events': 'Project On-Chain and Ecosystem Events Query',
  },
};
